import InfoIcon from "@mui/icons-material/Info";
import FeedbackDialog from "../../../../components/dialogs/FeedbackDialog.js";
import { HOST_STATUS } from "../../../../lib/constants.js";

const statusText = ({ locales }) => ({
  [HOST_STATUS.DEAD]: locales["maintenance.diagnostics.statusChange.dead"],
  [HOST_STATUS.HURT]: locales["maintenance.diagnostics.statusChange.hurt"],
  [HOST_STATUS.OK]: locales["maintenance.diagnostics.statusChange.repaired"],
});

export default function ConfirmationDialog({
  locales,
  newStatus,
  onClose,
  onConfirm,
  show,
}) {
  return (
    <FeedbackDialog
      actionButtonText={locales["maintenance.diagnostics.confirm"]}
      bodyPrimary={locales["maintenance.diagnostics.statusChange.subtitle"]}
      closeButtonText={locales["maintenance.diagnostics.cancel"]}
      icon={InfoIcon}
      locales={locales}
      onActionClick={onConfirm}
      onClose={onClose}
      show={show}
      title={statusText({ locales })[newStatus]}
    />
  );
}
